import { FC } from "react";
import RatingStarSVG from "../../svg/RatingStarIconSVG";
import { MAX_RATING } from "../../../../domain/constants";

interface StarsRatingProps {
    wrapClassName?: string;
    rate: number;
    setRate?: (value: number) => void;
}

const StarsRating: FC<StarsRatingProps> = (props) => {
    return props.setRate ? (
        <div className={`rating flex justify-center w-[237px] dmax2:w-[136px] ${props.wrapClassName}`}>
            <style>{`
                .rating {
                --star-filled: #C58811;
                --star-empty: #7A7A7E;
                transform: scaleX(-1);
                }
                .rating .star {
                color: var(--star-empty);
                display: inline-flex;
                transform: scaleX(-1);
                }
                .rating .star.is-filled { color: var(--star-filled); }
                .rating .star svg { transition: color .12s ease-in-out; }
                .rating .star:hover,
                .rating .star:hover ~ .star { color: var(--star-filled); }
            `}</style>
            {Array.from({ length: MAX_RATING }, (_, i) => MAX_RATING - i).map((value) => (
                <span
                    key={"rating_star_" + value}
                    className={`star ${value <= (props.rate || 0) ? "is-filled" : ""} ${
                        props.setRate ? "cursor-pointer" : ""
                    }`}
                    onClick={props.setRate ? () => props.setRate(value) : undefined}
                    role={props.setRate ? "button" : undefined}
                    aria-label={`${value} star`}
                >
                    <RatingStarSVG fill="currentColor" className="w-10 dmax2:w-6" />
                </span>
            ))}
        </div>
    ) : (
        <div className={`flex w-[237px] dmax2:w-[136px] ${props.wrapClassName}`}>
            {Array.from({ length: MAX_RATING }, (_, i) => i + 1).map((value) => (
                <RatingStarSVG
                    key={"rating_star_" + value}
                    fill={value <= props.rate ? "#C58811" : "#7A7A7E"}
                    className="w-10 dmax2:w-6"
                />
            ))}
        </div>
    );
};

export default StarsRating;
